import React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { ETestIds } from 'shared/constants/testIds';
import { ShadowWrapper } from 'shared/components/ShadowWrapper';

import {
  Title,
  ITitleProps,
  OfferBtn,
  IOfferBtnProps,
  Description,
  IDescriptionProps,
  LabelList,
  ILabelListProps,
  ConditionList,
  IConditionListProps,
  Banner,
  IBannerProps,
  Advertiser,
  IAdvertiserProps,
  Requirements,
  IRequirementsProps,
} from './components';
import styles from './styles.css';

export interface IOfferCardProps {
  title: ITitleProps;
  button: IOfferBtnProps;
  description: IDescriptionProps;
  conditions: IConditionListProps;
  requirements?: IRequirementsProps['requirements'];
  promotion?: IAdvertiserProps & IBannerProps;
  labels?: ILabelListProps['labels'];
  multiOfferBtn?: React.ReactNode;
  placeOnList: number;
}

export const OfferCard: React.FC<IOfferCardProps> = ({
  title,
  button,
  conditions,
  requirements,
  promotion,
  description,
  labels,
  multiOfferBtn,
  placeOnList,
}) => {
  const deviceType = useDeviceType();
  const hasLabels = labels && labels.length >= 1;
  const hasPromotion = promotion && promotion.bannerImgPaths && promotion.aboutAdvertiser;
  const hasRequirements = requirements && requirements.length;
  const isMultiOffer = Boolean(multiOfferBtn);

  return (
    <ShadowWrapper>
      <div className={styles['root']} data-testid={ETestIds.OfferCard}>
        <Title {...title} />
        {hasPromotion ? <Banner bannerImgPaths={promotion.bannerImgPaths} /> : null}
        <div className={cn(styles['container'], styles[deviceType])}>
          {Object.values(description).some(v => v !== undefined) ? <Description {...description} /> : null}
          {hasLabels ? <LabelList labels={labels} /> : null}
          {conditions ? <ConditionList {...conditions} /> : null}
          {hasRequirements ? <Requirements requirements={requirements} /> : null}
          {hasPromotion ? <Advertiser aboutAdvertiser={promotion.aboutAdvertiser} /> : null}
          <OfferBtn {...button} isMultiOffer={isMultiOffer} place={placeOnList} />
          {isMultiOffer ? <>{multiOfferBtn}</> : null}
        </div>
      </div>
    </ShadowWrapper>
  );
};
